<template>
  <el-link ref="rcLink" v-bind="$attrs" v-on="$listeners">
    <template v-for="slot in slots">
      <!-- 默认插槽 -->
      <slot v-if="isDefaultSlot(componentSlot(slot))" :name="slot">
        <template v-if="text">
          {{ text }}
        </template>
      </slot>

      <slot v-else :name="slot"></slot>
    </template>
  </el-link>
</template>

<script>
import { slotMixins } from "../mixins/slotMixins";
export default {
  name: "RcLink",
  mixins: [slotMixins],
  props: {
    text: [String, Number, Boolean],
    slots: {
      type: Array,
      default: () => ["default"]
    }
  }
};
</script>
